import axios from "axios";
import settings from "@/settings";
import router from "@/router";

const companyData = {
    identification_code: null,
    name: null,
    address: null,
    country: null,
    members: [],
    has_politically_exposed_person: 0,
    field_of_activity: null,
    agreed_terms: false,
    signer: null,
    link_hash: null,
    representative: {
        name: null,
        identification_code: null,
        country: "EE",
        proxy_file: null
    }
};

export default {
    namespaced: true,
    state: {
        company: {...companyData},
        notFilledFields: [],
        loading: false,
        signingLoading: false,
        showSuccess: true,
        showError: false,
        signingUrl: null,
        onboardings: [],
        selectedListStatusIndex: 0,
        listStatuses: ['completed', 'confirmed', 'failed', 'pending', 'all'],
        loadingOnboardingList: false,
        loadingOnboardingData: false,
        activeOnboarding: {},
    },
    mutations: {
        setFilledFields(state, val) {
            state.notFilledFields = []
            const allowedKeys = ['name', 'address', 'members', 'field_of_activity', 'country', 'email', 'phone_nr']
            if (val) {
                state.notFilledFields = Object.keys(val).filter(v => allowedKeys.includes(v) && !val[v]);
            }
        },
        setCompanyInformation(state, val) {
            state.company = {...state.company, ...val};
        },
        setLoading(state, val) {
            state.loading = val;
        },
        setSigningLoading(state, val) {
            state.signingLoading = val;
        },
        setLoadingOnboardingList(state, val) {
            state.loadingOnboardingList = val;
        },
        setLoadingOnboardingData(state, val) {
            state.loadingOnboardingData = val;
        },
        resetCompanyInformation(state) {
            state.company = {...companyData};
        },
        setShowSuccess(state, val) {
            state.showSuccess = val;
        },
        setShowError(state, val) {
            state.showError = val;
        },
        setSigningUrl(state, val) {
            state.signingUrl = val;
        },
        resetNotFilledFields(state) {
            state.notFilledFields = [];
        },
        setOnboardings(state, value) {
            state.onboardings = value;
        },
        setSelectedListStatusIndex(state, value) {
            state.selectedListStatusIndex = value;
            this.dispatch('onboarding/getOnboardings')
        },
        setActiveOnboarding(state, value) {
            state.activeOnboarding = value;
        },
        updateOnboardingProperty(state, { prop, value }) {
            state.activeOnboarding = {
                ...state.activeOnboarding,
                [prop]: value
            };
        },
    },
    actions: {
        // ADMIN PART
        async getOnboardings({commit, state}) {
            commit("setLoadingOnboardingList", true);
            commit("setRequestSuccess", false, {root: true});
            commit("setRequestError", false, {root: true});
            try {
                const params = {
                    'status': state.listStatuses[state.selectedListStatusIndex]
                }
                const response = await axios.get(settings.app_url + "/onboardings/", {params});
                const data = response.data;
                if (data.success === 1) {
                    commit("setOnboardings", data.onboardings);
                } else {
                    commit("setOnboardings", []);
                }
            } catch (e) {
                console.log("- ERROR -");
                console.log(e);
            }
            commit("setLoadingOnboardingList", false);
        },
        async getOnboardingData({commit}, onboardingId) {
            commit("setLoadingOnboardingData", true);
            commit("setRequestSuccess", false, {root: true});
            commit("setRequestError", false, {root: true});
            try {
                let response = await axios.get(settings.app_url + "/onboarding/" + onboardingId);
                if (response && response.data && response.status === 200 && response.data.success === 1) {
                    let data = response.data;
                    if (data.onboarding_data) commit("setActiveOnboarding", data.onboarding_data);
                } else {
                    commit("setActiveOnboarding", {
                        name: null,
                        identification_code: null,
                        status: null,
                    });
                    router.push("/admin/onboarding");
                }
            } catch (e) {
                console.log(e);
                commit("setRequestError", true, {root: true});
                commit("setErrorMessage", "Failed", {root: true});
            }
            commit("setLoadingOnboardingData", false);
        },

        async updateOnboardingData({commit, state}) {
            commit("setLoadingOnboardingData", true);
            commit("setRequestSuccess", false, {root: true});
            commit("setRequestError", false, {root: true});
            try {
                const payload = {
                    onboarding: state.activeOnboarding
                }
                return await axios.put(settings.app_url + "/onboarding/" + state.activeOnboarding.id, payload);
            } catch (e) {
                console.log(e);
                commit("setRequestError", true, {root: true});
                commit("setErrorMessage", "Failed", {root: true});
            }
            commit("setLoadingOnboardingData", false);
        },

        async confirmCurrentOnboarding({commit}, onboardingId) {
            commit("setLoadingOnboardingData", true);
            commit("setRequestSuccess", false, {root: true});
            commit("setRequestError", false, {root: true});
            try {
                let response = await axios.put(settings.app_url + "/onboarding-confirmation/" + onboardingId);
                commit("setLoadingOnboardingData", false);
                return response;
            } catch (e) {
                console.log(e);
                commit("setRequestError", true, {root: true});
                commit("setErrorMessage", "Failed", {root: true});
                commit("setLoadingOnboardingData", false);
            }
        },
        // LANDING PART
        async getCompanyInformation({commit}, {hash}) {
            commit("setLoading", true);
            commit("setRequestSuccess", false, {root: true});
            commit("setRequestError", false, {root: true});
            let success = false;
            try {
                const params = {hash};
                const response = await axios.get(`${process.env.VUE_APP_AS_API_URL}/app/landing/onboarding/`, {params});
                const data = response.data;
                if (data.success === 1) {
                    commit("setFilledFields", data?.onboarding)
                    commit("setCompanyInformation", data?.onboarding);
                    success = true;
                    if (data?.msg && data?.msg === 'already_done') {
                        commit('setShowSuccess', true)
                    }
                } else {
                    commit("resetCompanyInformation");
                    if (data.msg) {
                        commit("setRequestError", true, {root: true});
                        commit("setErrorMessage", data.msg, {root: true});
                    }
                }
            } catch (e) {
                console.log("- ERROR -");
                console.log(e);
                commit("setRequestError", true, {root: true});
                commit("setErrorMessage", "Failed", {root: true});
            }
            await commit("setLoading", false);
            return success;
        },
        async updateCompanyInformationAndCreateSigningLink({commit, state}) {
            commit("setLoading", true);
            commit("setSigningLoading", true);
            commit("setRequestSuccess", false, {root: true});
            commit("setRequestError", false, {root: true});
            try {
                let formData = new FormData();

                if (state.company?.representative?.proxy_file) {
                    formData.append("file", state.company?.representative?.proxy_file);
                }

                formData.append("data", JSON.stringify({...state.company, not_filled_fields: state.notFilledFields}));

                const response = await axios.post(`${process.env.VUE_APP_AS_API_URL}/app/landing/onboarding/`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                });
                const data = response.data;
                if (data.success === 1 && data?.url) {
                    await commit("setLoading", false);
                    await commit("setSigningLoading", false);
                    //await commit("setSigningUrl", data.url);
                    await commit("resetNotFilledFields");
                    return data.url;
                } else if (data.success === 0 && data?.dokobit_error) {
                    commit("setRequestError", true, {root: true});
                    commit("setErrorMessage", data.dokobit_error, {root: true});
                } else {
                    const message = data?.msg ? data.msg : this.t("Failed");
                    commit("setRequestError", true, {root: true});
                    commit("setErrorMessage", message, {root: true});
                }
            } catch (e) {
                console.log("- ERROR -");
                console.log(e);
                commit("setRequestError", true, {root: true});
                commit("setErrorMessage", "Failed", {root: true});
            }
            await commit("setLoading", false);
            return null;
        },
        async downloadDokobitFile({commit, state}) {
            commit("setLoading", true);
            commit("setRequestSuccess", false, {root: true});
            commit("setRequestError", false, {root: true});
            let success = false;
            try {
                const body = {link_hash: state.company.link_hash};
                const response = await axios.put(`${process.env.VUE_APP_AS_API_URL}/app/landing/onboarding/`, body);
                const data = response.data;
                if (data.success === 1) {
                    success = true;
                }
            } catch (e) {
                console.log("- ERROR -");
                console.log(e);
                commit("setRequestError", true, {root: true});
                commit("setErrorMessage", "Failed", {root: true});
            }
            await commit("setLoading", false);
            return success;
        },

        async deleteOnboarding({commit}, onboardingId) {
            commit("setLoadingOnboardingData", true);
            commit("setRequestSuccess", false, {root: true});
            commit("setRequestError", false, {root: true});
            try {
                let response = await axios.delete(settings.app_url + "/onboarding/" + onboardingId);
                commit("setLoadingOnboardingData", false);
                commit("setRequestSuccess", true, {root: true});
                return response;
            } catch (e) {
                console.log(e);
                commit("setRequestError", true, {root: true});
                commit("setErrorMessage", "Failed", {root: true});
                commit("setLoadingOnboardingData", false);
            }
        },
    }
}